"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { type ReactNode, useMemo } from "react";
import useIsNativeApp from "@/hooks/use-is-native-app";
import { useIsMobile } from "@/hooks/use-mobile";
import BottomNavigation from "../pop-ui/bottom-navigation";
interface ConditionalLayoutProps {
  children: ReactNode;
  headerContent?: ReactNode;
  footerContent?: ReactNode;
  additionalContent?: ReactNode; // 额外的组件内容，如广告、指纹等
}

/**
 * 条件性渲染布局组件
 * 检查当前页面是否为停服页面，如果是则不渲染Header、Footer和其他额外组件
 * 检查是否来自App，如果是则不渲染Header和Footer
 */
export function ConditionalLayout(t0) {
  const $ = _c(18);
  const {
    children,
    headerContent,
    footerContent,
    additionalContent
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = pathname.includes("/shutdown");
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isShutdownPage = t1;
  const isFromApp = useIsNativeApp();
  let t2;
  if ($[2] !== pathname) {
    t2 = pathname.includes("/webview");
    $[2] = pathname;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isWebViewPage = t2;
  const mobileNoHeaderAndFooterRoutes = ["/payment"];
  const isMobile = useIsMobile();
  const isNoHeaderRoute = isMobile && mobileNoHeaderAndFooterRoutes.some(route => pathname.includes(route)) || isShutdownPage || isFromApp || isWebViewPage;
  let t3;
  if ($[4] !== isMobile || $[5] !== pathname) {
    t3 = isMobile && pathname.endsWith("/category");
    $[4] = isMobile;
    $[5] = pathname;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const isCategoryPageWithoutParams = t3;
  const isNoFooterRoute = isMobile && mobileNoHeaderAndFooterRoutes.some(route_0 => pathname.includes(route_0)) || isCategoryPageWithoutParams || isShutdownPage || isFromApp || isWebViewPage;
  const t4 = !isNoHeaderRoute && headerContent;
  const t5 = isShutdownPage ? "shutdown" : undefined;
  const t6 = children as any;
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <main data-testid="global-main-content" data-page={t5} className="flex-1">{t6}</main>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = !isNoFooterRoute && footerContent;
  const t9 = !isNoFooterRoute && additionalContent;
  let t10;
  if ($[10] !== isFromApp) {
    t10 = !isFromApp && <BottomNavigation />;
    $[10] = isFromApp;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t4 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t11 = <>{t4}{t7}{t8}{t9}{t10}</>;
    $[12] = t10;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}